__turbopack_context__.v({
  "container": "ProfileMenu-module-scss-module__sbjlha__container",
  "email": "ProfileMenu-module-scss-module__sbjlha__email",
  "header": "ProfileMenu-module-scss-module__sbjlha__header",
  "headerName": "ProfileMenu-module-scss-module__sbjlha__headerName",
  "isOpen": "ProfileMenu-module-scss-module__sbjlha__isOpen",
  "name": "ProfileMenu-module-scss-module__sbjlha__name",
  "subtitle": "ProfileMenu-module-scss-module__sbjlha__subtitle",
  "trigger": "ProfileMenu-module-scss-module__sbjlha__trigger",
  "triggerText": "ProfileMenu-module-scss-module__sbjlha__triggerText",
});
